import React from 'react';
import ReactApexChart from 'react-apexcharts';

const RideBarChart = ({ first_chart_data }) => {
    const years = Object.keys(first_chart_data || {});
    const whatsappData = years.map(year => first_chart_data[year]?.wts_bookings || 0);
    const partnerData = years.map(year => first_chart_data[year]?.pt_bookings || 0);
    const kycData = years.map(year => first_chart_data[year]?.kyc_bookings || 0);

    const totalWhatsapp = whatsappData.reduce((acc, val) => acc + val, 0);
    const totalPartner = partnerData.reduce((acc, val) => acc + val, 0);
    const totalKyc = kycData.reduce((acc, val) => acc + val, 0);

    const balanceStatisticsOptions = {
        colors: ['#487FFF', '#FF9F29', '#10B981'], // Blue, Orange, Green
        labels: ['WhatsApp Rides', 'Partner Rides', 'KYC Rides'],
        legend: {
            show: false,
        },
        chart: {
            type: 'bar',
            height: 150,
            toolbar: {
                show: false,
            },
        },
        grid: {
            show: true,
            borderColor: '#D1D5DB',
            strokeDashArray: 4,
            position: 'back',
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                columnWidth: 10,
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent'],
        },
        xaxis: {
            categories: years,
            labels: {
                style: {
                    fontSize: '12px',
                },
            },
        },
        yaxis: {
            labels: {
                style: {
                    fontSize: '12px',
                },
            },
        },
    };

    const balanceStatisticsSeries = [
        {
            name: 'WhatsApp Rides',
            data: whatsappData,
        },
        {
            name: 'Partner Rides',
            data: partnerData,
        },
        {
            name: 'KYC Rides',
            data: kycData,
        },
    ];

    return (
        <div className='card-body'>
            <ul className='d-flex flex-wrap align-items-center justify-content-center mt-3 gap-3'>
                <li className='d-flex align-items-center gap-2'>
                    <span className='w-12-px h-12-px rounded-circle' style={{ backgroundColor: '#487FFF' }} />
                    <span className='text-secondary-light text-sm fw-semibold'>
                        WhatsApp Rides:{' '}
                        <span className='text-primary-light fw-bold'>{totalWhatsapp}</span>
                    </span>
                </li>
                <li className='d-flex align-items-center gap-2'>
                    <span className='w-12-px h-12-px rounded-circle' style={{ backgroundColor: '#FF9F29' }} />
                    <span className='text-secondary-light text-sm fw-semibold'>
                        Partner Rides:{' '}
                        <span className='text-primary-light fw-bold'>{totalPartner}</span>
                    </span>
                </li>
                <li className='d-flex align-items-center gap-2'>
                    <span className='w-12-px h-12-px rounded-circle' style={{ backgroundColor: '#10B981' }} />
                    <span className='text-secondary-light text-sm fw-semibold'>
                        KYC Rides:{' '}
                        <span className='text-primary-light fw-bold'>{totalKyc}</span>
                    </span>
                </li>
            </ul>
            <div className='row'>
                <div className='mt-40 col-12'>
                    <ReactApexChart
                    height={350}
                        options={balanceStatisticsOptions}
                        series={balanceStatisticsSeries}
                        type='bar'
                    />
                </div>
            </div>
        </div>
    );
};

export default RideBarChart;
